import moment from "moment";
import "./ShowDate.less";
import React from "react";
import { useIntl } from "react-intl";

type TaskDateType = "created" | "deadline";

type ShowDateProps = {
   date: Date | string | null | undefined;
   className?: string;
   dateType: TaskDateType;
};

const ShowDate: React.FC<ShowDateProps> = ({ date, className = "", dateType }) => {
   const i = useIntl();

   const dateConfigMap: Record<TaskDateType, { label: string; noDate: string }> = {
      created: {
         label: i.formatMessage({ id: "planner.creationDate" }),
         noDate: i.formatMessage({ id: "planner.noCreationDate" }),
      },
      deadline: {
         label: i.formatMessage({ id: "planner.deadlineDate" }),
         noDate: i.formatMessage({ id: "planner.noDeadline" }),
      },
   };
   const config = dateConfigMap[dateType];
   const dateLabel = config?.label ?? "";
   const noDateMessage = config?.noDate ?? "";

   const isValidDate = date && moment(date).isValid();
   const formattedDeadlineDate = isValidDate ? moment(date).format("DD.MM.YYYY HH:mm") : null;

   return (
      <p className={`${className} p3 show-date`}>
         <span className="show-date__label">{dateLabel}:</span>{" "}
         <span>{formattedDeadlineDate ? formattedDeadlineDate : noDateMessage}</span>
      </p>
   );
};

export default ShowDate;
